import {Navigate, Outlet, useLocation} from "react-router-dom";
import {useAuth} from "@/hooks/useAuth";
import {AuthGateLoader} from "./AuthGateLoader";

export const RequireGuest = () => {
  const location = useLocation();
  const {isAuthenticated, isLoading} = useAuth();

  if (isLoading && location.pathname.startsWith("/auth")) return <AuthGateLoader />;

  return isAuthenticated ? <Navigate to="/app" replace /> : <Outlet />;
};
